class SectionHero extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector(".swiper");
    this.swiperDelay = Number(this.dataset.delay);
    this.swiperParams = {
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: this.swiperDelay,
        disableOnInteraction: false,
      },
    };

    if (this.swiperDelay === 0) {
      this.swiperParams = {
        slidesPerView: 1,
        autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };
    }

    window.loadSwiper.then(({ Swiper }) => {
      this.swiper = new Swiper(this.swiperEl, this.swiperParams);
    });
  }

  connectedCallback() {
    window.addEventListener("shopify:block:select", (e) => {
      if (this.swiper) {
        let blockId = e.detail.sectionId + "__" + e.detail.blockId;
        let slideEl = [...this.swiperEl.querySelectorAll(".hero__slide")].find(
          (slide) => {
            let editorData = JSON.parse(slide.dataset.shopifyEditorBlock);
            return editorData.id == blockId;
          },
        );
        console.log(slideEl);
        if (slideEl) this.swiper.slideTo(slideEl.dataset.index);
      }
    });
  }
}

if (!customElements.get("section-hero")) {
  customElements.define("section-hero", SectionHero);
}
